import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';

export class ConfirmDialogData {
  title: string = 'Are you sure?';
  message: string;
  showFollowUpReason?: boolean;
  yesText?: string;
  noText?: string;
  hideNoButton?: boolean;
}

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  form: FormGroup;
  showFollowUpReason: boolean;

  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private fb: FormBuilder
  ) {
    this.showFollowUpReason = data.showFollowUpReason || false;
    this.form = this.fb.group({
      reason: [''],
    });
  }

  onConfirm(): void {
    const result = this.showFollowUpReason
      ? { confirmed: true, reason: this.form.value.reason }
      : { confirmed: true };

    this.dialogRef.close(result);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
